import { lazy } from 'react';
 
export const routes = [
    {
        path: "/contact",
        exact: true,
        component: lazy(() => import("./components/Contact")),
        name: "Contact"
    }
];
